import AnalyticsEngineCIMBase from "./../../../../src/common/analytics/engines/analyticsEngineCIMBase";
import { stripHtm } from "../../../../src/common/utilities/utils";

export default class AnalyticsEngineCIM extends AnalyticsEngineCIMBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
  }

  sendPageView(data) {
    const {
      eventData: { bundle },
    } = data;
    const pages = bundle.publication.pages;
    if (pages.length > 0) {
      pages.forEach((page) => {
        window.trmfn_public.trackPageView({
          schema: "iglu:com.twipemobile.article/context/jsonschema/1-0-0",
          data: {
            woodwingId: page.pageReference,
          },
        });
      });
    }
  }

  sendALB(data) {
    const {
      eventData: {
        bundle: {
          publication: { pages },
        },
      },
    } = data;
    const articles = pages[0].articles;
    const title = stripHtm(articles[0].title);
    const articleId = articles[0].articleReference;
    const author = articles[0].author;
    window.trmfn_public.trackPageView({
      schema: "iglu:com.twipemobile.article/context/jsonschema/1-0-0",
      data: {
        woodwingId: articleId,
        title: title,
        author: author,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./clients/mfn-tij/js/engines/analyticEngineCIM.js